import { Box, Button, Typography } from '@mui/material';
import React from 'react';

import { StepComponentProps } from 'components/Flow/RenderMachine';
import SplashWrapper from 'retired/SplashWrapper';
import { BackButton } from 'components/BackButton/BackButton';
import { gray, gray5, purple } from 'utils/color-styles';

import { ScrollContainer } from './Components/ScrollContainer';

export const Gov = ({ send }: StepComponentProps) => (
  <SplashWrapper>
    <ScrollContainer
      bottom={
        <Box display="flex" alignItems="center" bgcolor="white" pt={2} mt={3}>
          <BackButton size={40} color={gray5} onClick={() => send('PREV')} />
          <Box ml={2}>
            <Button
              size="small"
              variant="contained"
              onClick={() => {
                send('CREATE_GOV');
              }}
              style={{ padding: '10px 15px', backgroundColor: purple }}
            >
              Proceed to Create Government Entity Profile
            </Button>
          </Box>
        </Box>
      }
    >
      <Typography variant="h4" fontWeight={500} lineHeight="38px" mb={2}>
        Government Entity that is Not a 501(c)(3) Charitable Organization
      </Typography>
      <Typography fontSize={15} lineHeight="38px" mb={2}>
        To proceed with creating a profile for a government entity, we need to confirm a few details
        to ensure your organization is classified correctly. This helps us provide the most relevant
        resources and support.
      </Typography>
      <Typography fontSize={15} fontWeight={500} lineHeight="38px" mb={2}>
        Verification Requirements
      </Typography>
      <ul style={{ paddingLeft: 12 }}>
        <li>
          <Typography fontSize={15} lineHeight="38px" mb={1}>
            A 4076c Government Entity Letter from the IRS
          </Typography>
          <Typography fontSize={12} lineHeight="38px" mb={2} color={gray}>
            For more detailed information on the 4076C letter and how to request it, visit the{' '}
            <a
              target="_blank"
              href="https://www.irs.gov/government-entities/federal-state-local-governments/governmental-information-letter"
            >
              IRS website
            </a>
            .
          </Typography>
        </li>
        <li>
          <Typography fontSize={15} lineHeight="38px" mb={1}>
            Letter of association if YOUR organization is a department of the legal entity listed
            above.
          </Typography>
        </li>
        <li>
          <Typography fontSize={15} lineHeight="38px" mb={1}>
            Bank statement, canceled check, or bank letter: (copy of a bank statement, canceled
            check, or a bank letter dated within the last two years, which includes our
            organization&apos;s name, tax ID, and full account number).
          </Typography>
        </li>
      </ul>

      <Typography fontSize={15} fontWeight={500} lineHeight="38px" mb={2}>
        Next Steps
      </Typography>

      <ul style={{ paddingLeft: 12 }}>
        <li>
          <Typography fontSize={15} lineHeight="38px">
            If you have these documents ready, please click on the link below to create your
            government entity profile.
          </Typography>
        </li>
      </ul>
    </ScrollContainer>
  </SplashWrapper>
);
